import React from 'react';
import { MapPin, Phone, Clock, Navigation, Instagram } from 'lucide-react';

const Footer = () => {
  const handleDirections = () => {
    window.open('https://share.google/twxsywfeuXj2511vf', '_blank');
  };

  const handleInstagram = () => {
    window.open('https://www.instagram.com/o2nails_hyd/', '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-section">
              <div className="footer-item">
                <MapPin className="footer-icon" />
                <div className="footer-text">
                  <p className="footer-label">Visit Us</p>
                  <p className="footer-value">
                    Unit No. 1F-59, 1st Floor<br />
                    Sarath City Capital Mall<br />
                    Kondapur, Whitefields, Gachibowli<br />
                    Hyderabad, Telangana 500084
                  </p>
                  <button 
                    onClick={handleDirections}
                    className="directions-button"
                  >
                    <Navigation className="directions-icon" />
                    Get Directions
                  </button>
                </div>
              </div>
            </div>

            <div className="footer-section">
              <div className="footer-item">
                <Phone className="footer-icon" />
                <div className="footer-text">
                  <p className="footer-label">Call Us</p>
                  <a href="tel:+918317599282" className="footer-value footer-link">
                    +91 83175 99282
                  </a>
                </div>
              </div>
              <div className="footer-item" style={{ marginTop: '20px' }}>
                <Instagram className="footer-icon" />
                <div className="footer-text">
                  <p className="footer-label">Follow Us</p>
                  <button 
                    onClick={handleInstagram}
                    className="instagram-button-footer"
                    aria-label="Follow us on Instagram"
                  >
                    <span>@o2nails_hyd</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="footer-section">
              <div className="footer-item">
                <Clock className="footer-icon" />
                <div className="footer-text">
                  <p className="footer-label">Opening Hours</p>
                  <p className="footer-value">
                    10:30 AM - 9:30 PM<br />
                    All Days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-seo-text">
            O2 Nails Hyd – Rated among the best nail salons in Hyderabad.
            <br />
            Proudly serving clients across Kondapur, Hitech City, Gachibowli & Madhapur.
          </p>
          <p className="footer-copyright">
            © {new Date().getFullYear()} O2 Nails Hyd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
